import React, { useState, useRef, useEffect } from 'react';
import { User } from 'lucide-react';
import { DropDownMenu, SmallDropDownMenu } from '../shareable/dropdownMenu';
import SearchInput from '../shareable/searchInput';
import { dropmenuitems } from './items';
import { useAuth } from '../../context/authContext';
import { useSearch } from '../../context/SearchContext';
import { useLocation } from 'react-router-dom';

const Header = () => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { user, logout } = useAuth();
  const { currentPage } = useSearch();
  const location = useLocation();

  // Routes where search should be hidden
  const hideSearchRoutes = ['/new-quote', '/update-quote/', '/profile'];
  
  const shouldHideSearch = hideSearchRoutes.some(route => 
    location.pathname.startsWith(route)
  );

  // Check if we're specifically on the new-quote route
  const isNewQuoteRoute = location.pathname === '/new-quote';
  
  // Check if we're on an update route
  const isUpdateRoute = location.pathname.startsWith('/update-quote/');
  
  // Determine if we should use small header styling
  const isSmallHeader = isNewQuoteRoute || isUpdateRoute;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className={`bg-white shadow flex justify-between items-center relative transition-all duration-300 ${
      isSmallHeader ? 'py-2 px-2' : 'py-4 px-2'
    }`}>
      {/* Conditionally render content based on route */}
      {!shouldHideSearch ? (
        <div className="flex justify-center w-full">
          <SearchInput className="w-full max-w-md" page={currentPage} />
        </div>
      ) : isNewQuoteRoute ? (
        <div className="flex justify-center w-full">
          <h2 className={`font-bold text-center text-red-700 uppercase tracking-tight transition-all duration-300 ${
            isSmallHeader ? 'text-xl' : 'text-2xl'
          }`}>
            BABS Conveyor Builder
          </h2>
        </div>
      ) : isUpdateRoute ? (
        <div className="flex justify-center w-full">
          <h2 className={`font-bold text-center text-red-700 uppercase tracking-tight transition-all duration-300 ${
            isSmallHeader ? 'text-xl' : 'text-2xl'
          }`}>
            Update Quote
          </h2>
        </div>
      ) : (
        <div className="flex-1"></div> // Empty div to maintain layout for other routes
      )}
      
      <div
        className={`relative flex items-center space-x-2 transition-all duration-300 ${
          isSmallHeader ? 'right-2' : 'right-4'
        }`}
        ref={dropdownRef}
        onClick={() => setOpen((prev) => !prev)}
      >
        <div className={`rounded-full bg-gray-300 flex items-center justify-center cursor-pointer transition-all duration-300 ${
          isSmallHeader ? 'p-1 w-6 h-6' : 'p-1 w-8 h-8'
        }`}>
          <User className="text-white" size={isSmallHeader ? 14 : 18} />
        </div>
        
        {/* Use SmallDropDownMenu on new quote page, regular one otherwise */}
        {isNewQuoteRoute ? (
          <SmallDropDownMenu 
            open={open} 
            title={user?.name || ""} 
            items={dropmenuitems.items}
            onLogout={logout}
          />
        ) : (
          <DropDownMenu 
            open={open} 
            title={user?.name || ""} 
            items={dropmenuitems.items}
          />
        )}
      </div>
    </header>
  );
};

export default Header;
